module.exports = __webpack_public_path__ + "static/tas-e7053c5ccf2d48491151050afe929c95.png";